module.exports = __webpack_public_path__ + "img/League_10.bc60fe26.png";